import { Form, Input } from "decorator-form";
import { Entity, Field } from "typegraph";

import EntitySelect from 'common/form/fields/entitySelect/EntitySelect';
import InputType from 'common/form/InputType';
import { TLayout } from "common/form/widgets/layout/LayoutHelper";
import ListOrderWidget from "common/form/widgets/listOrder/ListOrderWidget";
 // import ProgramMeta from "./component/ProgramMeta";

// tslint:disable
@Entity({one: 'program', many: 'programs'})
class Program {
	@Field()
	public id: string;
	@Field()
	public name: string;
}

const programField = EntitySelect.registered({entity: Program, type: 'one'}, 'string');

@Form({title: "Selected Program Panel Config"})
export default class ProgramConfig {

	@Input({type: programField, title: "Select Program (if blank, will check url for program id)"})
	public programId?: number;

	@Input({type: InputType.CHECKBOX, title: "Wrap Tracks In Box"})
	public wrapTracks?: boolean;


	// might not be keeping:

	@Input({type: InputType.CHECKBOX, title: "Show Description"})
	public showDescription: boolean = true;

	@Input({type: InputType.CHECKBOX, title: "Show Program Progress"})
	public showProgress: boolean = true;

	@Input({type: InputType.CHECKBOX, title: "Show Track-Level Progress Bars"})
	public showTrackProgress: boolean = false;

	@Input({type: InputType.CHECKBOX, title: "Progress Circle Instead of Bar"})
	public useProgressCircle: boolean = false;

	@Input({type: InputType.CHECKBOX, title: "Show Track Details Link"})
	public enableTrackDetailsLink: boolean;

}



// WEBPACK FOOTER //
// ./src/panels/program/ProgramConfig.ts